var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00145 5.4976C7.45908 5.4976 8.64072 4.37885 8.64072 2.9988C8.64072 1.61875 7.45908 0.5 6.00145 0.5C4.54382 0.5 3.36218 1.61875 3.36218 2.9988C3.36218 4.37885 4.54382 5.4976 6.00145 5.4976Z",
    stroke: "#1495DD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09998 11.2109C1.09998 8.64799 3.29445 6.57031 6.00147 6.57031C8.70849 6.57031 10.903 8.64799 10.903 11.2109",
    stroke: "#1495DD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.2378a42d7dcbbbfcadfe487915d95b35.svg";
export { ForwardRef as ReactComponent };